<template>
  <div class="working-hours">
    <div class="working-hours__logo sf-secondary">
      <clock/>
    </div>
    <h3 class="sf-mb-s">{{ $t("contacts-page.working-hours-title") }}</h3>
    <div class="sf-mb-s">{{ $t("contacts-page.days") }}</div>
    <div class="sf-mb-s">{{ $t("contacts-page.hours") }}</div>
  </div>
</template>

<script>
import Clock from '~/static/img/contacts/clock.svg';

export default {
  name: 'ContactsWorkingHours',
  components: { Clock },
};
</script>

<style lang="scss" scoped>
.working-hours {
  font-size: 20px;
  line-height: 30px;

  &:not(:last-child) {
    padding-right: map-get($paddings, small);
  }

  @include mobile {
    &:not(:first-child) {
      margin-top: map-get($margins, normal);
    }
  }

  &__logo {
    @include square(85px);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: map-get($margins, small);
    border-radius: 50%;

    @include mobile {
      @include square(60px);
    }

    svg {
      @include square(70%);
    }
  }
}
</style>
